import { render, staticRenderFns } from "./PublicContestDataTableIcon.vue?vue&type=template&id=b36f85f8&scoped=true&"
import script from "./PublicContestDataTableIcon.vue?vue&type=script&lang=js&"
export * from "./PublicContestDataTableIcon.vue?vue&type=script&lang=js&"
import style0 from "./PublicContestDataTableIcon.vue?vue&type=style&index=0&id=b36f85f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f85f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VTooltip})
